import { render, staticRenderFns } from "./DataTableWithTwoColumns.vue?vue&type=template&id=76c334e9&scoped=true"
import script from "./DataTableWithTwoColumns.vue?vue&type=script&lang=js"
export * from "./DataTableWithTwoColumns.vue?vue&type=script&lang=js"
import style0 from "./DataTableWithTwoColumns.vue?vue&type=style&index=0&id=76c334e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c334e9",
  null
  
)

export default component.exports